import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface ICustomHeaderParams {
    activeStatusCriteria: boolean;
    sortable: boolean;
    currentSort: string;
    //selectedSort: (columnName: string, currentSort: string)=> void;
}

@Component({
  selector: 'status-report-header',
  templateUrl: "./status-report-header.component.html",
  styleUrls: ['./status-report-header.component.scss']
})
export class StatusReportHeader implements IHeaderAngularComp {
  public params!: IHeaderParams & ICustomHeaderParams;

  activeStatusCriteria: boolean;
  sortable: boolean;
  ascSort: string;
  descSort: string;
  noSort: boolean;
  currentSort: string;
  @Output()
  //selectedSort: (columnName: string, currentSort: string)=> void;

  agInit(params: IHeaderParams & ICustomHeaderParams): void {
    this.params = params;
  }

  onAsc(){
    if(this.ascSort == 'active' || null){
        this.ascSort = 'inactive';
        this.currentSort = null
    }
    else{
        this.descSort = 'inactive';
        this.ascSort = 'active';
        this.currentSort = 'asc';
    }
    //this.selectedSort(this.params.displayName, this.currentSort);
  }
  onDesc(){
    if(this.descSort == 'active' || null){
        this.descSort = 'inactive';
        this.currentSort = null
    }
    else{
        this.ascSort = 'inactive';
        this.descSort = 'active';
        this.currentSort = 'desc';
    }
    //this.selectedSort(this.params.displayName, this.currentSort);
  }

  refresh(params: IHeaderParams) {
    return false;
  }
}